import { all, fork } from "redux-saga/effects";
import { watchDashboardCountSaga } from "./dashboardCount";

export default function* rootDashboardCountSagas() {
    yield all([
       fork(watchDashboardCountSaga),
    ])
}